import {
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	TextField,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { closeModal } from '../../../redux/modals/action';
import Modal from '../../layout/modal/Modal';
import styles from './FilterLeads.module.scss';
import { onlyUnique } from '../../../utils/onlyUniqueArrays';
import { applyFilters } from '../../../redux/filter/actions';

const Filterleads = ({
	openModal,
	closeModal,
	leads,
	salesAgents,
	applyFilters,
	filter,
}) => {
	const [postalCodes, setPostalCodes] = useState([]);
	const [buyerTypes, setBuyerTypes] = useState([]);
	const [sources, setSources] = useState([]);
	const [dropdown, setDropdown] = useState({});

	useEffect(() => {
		// setDropdown(filter);
		setDropdown({});
	}, [filter]);
	useEffect(() => {
		var postalCodeArr = [];
		var buyerTypeArr = [];
		var sourceArr = [];

		leads.map((lead) => {
			var split = lead?.postalCode?.substring(0, 3);

			postalCodeArr.push(split);
			buyerTypeArr.push(lead.buyerType);
			sourceArr.push(lead.reference);
		});

		setPostalCodes(postalCodeArr.filter(onlyUnique));
		setBuyerTypes(buyerTypeArr.filter(onlyUnique));
		setSources(sourceArr.filter(onlyUnique));
	}, [leads]);

	const handleChange = (e) => {
		setDropdown({
			...dropdown,
			[e.target.name]: e.target.value,
		});
	};

	const handleApply = () => {
		var array = [];
		// for (var key in dropdown) {
		// 	if (dropdown[key] !== 'default') {
		// 		array.push({ [key]: dropdown[key] });
		// 	} else {
		// 		array.push({ [key]: '' });
		// 	}
		// }

		console.log('handleApply ', dropdown);
		applyFilters('leadsFilter', dropdown);
		closeModal('filterLeads');
	};

	return (
		<div className={styles.leadsFilterWrapper}>
			<Modal
				show={openModal}
				close={() => closeModal('filterLeads')}
				title='Filters'
			>
				{/* <div className={styles.title}>Filters</div> */}
				<div className={styles.fieldGroup}>
					<FormControl className={styles.textFieldItem}>
						<TextField
							variant='outlined'
							name={'postalCode'}
							onChange={(e) => handleChange(e)}
							value={dropdown.postalCode ?? 'default'}
							defaultValue={'default'}
							select
							className={styles.textFieldDropdown}
							MenuListProps={{ disablePadding: true }}
						>
							<MenuItem
								className={styles.agentItem}
								value={'default'}
							>
								# Postal Code
							</MenuItem>
							{postalCodes?.map((postalCode, index) => {
								return (
									<MenuItem
										className={styles.agentItem}
										value={postalCode}
										key={index}
									>
										{postalCode}
									</MenuItem>
								);
							})}
						</TextField>
					</FormControl>

					<hr className={styles.separator} />

					<FormControl className={styles.textFieldItem}>
						<TextField
							variant='outlined'
							name={'agent'}
							onChange={(e) => handleChange(e)}
							value={dropdown.agent ?? 'default'}
							defaultValue={'default'}
							select
							className={styles.textFieldDropdown}
							MenuListProps={{ disablePadding: true }}
						>
							<MenuItem
								className={styles.agentItem}
								value={'default'}
							>
								Select Agent
							</MenuItem>
							{salesAgents?.map((salesAgent, index) => (
								<MenuItem
									className={styles.agentItem}
									value={salesAgent}
									key={index}
								>
									{salesAgent.salesAgentName}
								</MenuItem>
							))}
						</TextField>
					</FormControl>
					<FormControl className={styles.textFieldItem}>
						<TextField
							variant='outlined'
							name={'buyerType'}
							onChange={(e) => handleChange(e)}
							value={dropdown.buyerType ?? 'default'}
							defaultValue={'default'}
							select
							className={styles.textFieldDropdown}
							MenuListProps={{ disablePadding: true }}
						>
							<MenuItem
								className={styles.agentItem}
								value={'default'}
							>
								Type of buyer
							</MenuItem>
							{buyerTypes?.map((buyerType, index) => {
								return (
									<MenuItem
										className={styles.agentItem}
										value={buyerType}
										key={index}
									>
										{buyerType}
									</MenuItem>
								);
							})}
						</TextField>
					</FormControl>
					<FormControl className={styles.textFieldItem}>
						<TextField
							variant='outlined'
							name={'source'}
							onChange={(e) => handleChange(e)}
							value={dropdown.source ?? 'default'}
							defaultValue={'default'}
							select
							className={styles.textFieldDropdown}
							MenuListProps={{ disablePadding: true }}
						>
							<MenuItem
								className={styles.agentItem}
								value={'default'}
							>
								How did you hear about us?
							</MenuItem>
							{sources?.map((source, index) => {
								return (
									<MenuItem
										className={styles.agentItem}
										value={source}
										key={index}
									>
										{source}
									</MenuItem>
								);
							})}
						</TextField>
					</FormControl>
				</div>
				<div className={styles.button} onClick={() => handleApply()}>
					Apply
				</div>
			</Modal>
		</div>
	);
};

const mapStateToProps = (state) => ({
	salesAgents: state.leads.salesAgents,
	leads: state.leads.leads,
});

export default connect(mapStateToProps, { closeModal, applyFilters })(
	Filterleads
);
